"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentCardSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SkeletonRoot = (0, _mui.styled)(_styles.Root)(({
  theme
}) => ({
  gap: theme.spacing(4)
}));
const PaymentCardSkeleton = ({
  className
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(SkeletonRoot, {
  className: className,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    width: 150,
    height: 45
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    width: "100%",
    height: 45
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    width: "100%",
    height: 45
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
    width: "100%",
    height: 45
  })]
});
exports.PaymentCardSkeleton = PaymentCardSkeleton;
